import React, {useEffect, useState} from 'react';
import {Route, Switch, useHistory} from "react-router-dom";
import asyncComponent from "../../../util/asyncComponent";
import SearchResultsPage from "./routes/SearchResultsPage";
import {useDispatch, useSelector} from "react-redux";
import {
    bbDoesCustomerHaveAccessToSubscription,
    bbDoesCustomerHaveAccessToSubscriptionLevel,
    bbDoesUserHaveAccessToBreachRiskLevelForAnyEntity, bbDoesUserHaveAccessToBreachRiskLevelForEntity,
    bbFindEntityWithinPortfolioOrSelf,
    bbGetSubscriptionLevelPropertyFromIdOrName,
    bbGetSubscriptionPropertyFromIdOrName, getFirstCustomerId,
    isCurrentUserMemberOf
} from "../../../util/bbHelpers";
import {
    fetchCustomers, fetchRiskCycleDetailsPagewise,
    fetchRiskCycleReport,
    fetchRiskPortfolio,
    setCustomerInView,
    setEntityInView
} from "../../../actions";

function SearchRoutes({match}){
    return(
        <Switch>
            <Route path={`${match.url}/`} component={SearchResultsPage}/>
            <Route component={asyncComponent(() => import('app/routes/extraPages/routes/404'))}/>
        </Switch>
    );
}

const SearchPageRoutes = ({match}) => {
    const {customers, customerInView} = useSelector(({customer}) => customer);
    const {authUser} = useSelector(({auth}) => auth);
    const history = useHistory();
    const dispatch = useDispatch();

    const customer = customers ? customers[customerInView] : null;

    const {entityInView, portfolios, loadingPortfolios, selfEntityId, loadingCycles, loadingCycleDetails, loadingCycleSocial} = useSelector(({breachrisk}) => breachrisk);

    const customerIdToUse = customers ? customerInView ? customerInView : null : null;
    const myEntity = bbFindEntityWithinPortfolioOrSelf(entityInView, portfolios, customerIdToUse);
    const [cycleInView, setCycleInView] = useState(myEntity && myEntity.settings && myEntity.settings.last_cycle_id)

    const isTrustedAgent = bbDoesUserHaveAccessToBreachRiskLevelForAnyEntity(authUser, "infoLevel3");
    const isPartner = isCurrentUserMemberOf(authUser, "partner");
    const isAdmin =  isCurrentUserMemberOf(authUser, "admin");
    const isStaff = isCurrentUserMemberOf(authUser, "staff");
    const subscriptions = customer && Object.values(customer.Subscriptions)
    const hasActiveBRfBSubscription = subscriptions && subscriptions.filter((sub)=> sub.subscription_type && sub.subscription_type.id === 2 && sub.is_active).length;
    const isBRBusinessCustomer = hasActiveBRfBSubscription || bbDoesCustomerHaveAccessToSubscription(customer, 2);
    const hasBRBusinessRole = isCurrentUserMemberOf(authUser,"breachrisk")

    const hasPremiumSubscription = bbDoesCustomerHaveAccessToSubscriptionLevel(customer, 2, 11);

    const applicableSubscriptionTypeId = bbGetSubscriptionPropertyFromIdOrName("BRfB", "id");
    const applicableSubscriptionLevelId = bbGetSubscriptionLevelPropertyFromIdOrName("lite", "id");
    const doesUserHaveALiteSubscriptionOrHigher = bbDoesCustomerHaveAccessToSubscriptionLevel(customer, applicableSubscriptionTypeId, applicableSubscriptionLevelId, true);

    const techData = myEntity
    && myEntity.last_cycle
    && myEntity.last_cycle.cycle
    && myEntity.cycles
    && myEntity.cycles[cycleInView]
        ? myEntity.cycles[cycleInView].techData
        : null;
    
    useEffect(()=>{
        if (customers == null && authUser) {
            dispatch(fetchCustomers());
        }
        if (customers && customerInView === null) {
            const defaultId = getFirstCustomerId(customers);
            dispatch(setCustomerInView(defaultId));
        }
    }, [customers, customerInView])

    useEffect(()=>{
        if (customers
            && customer
            && authUser
            && !portfolios
            && !loadingPortfolios[customerInView]) {
            dispatch(fetchRiskPortfolio({
                customerId: customerIdToUse
            }));
        }
    },[portfolios, loadingPortfolios[customerInView]])


    useEffect(()=>{
        setCycleInView( myEntity
            && myEntity.last_cycle
            && myEntity.last_cycle.cycle);
    },[entityInView])

    useEffect(()=>{
        if(portfolios
            && portfolios[customerIdToUse]
            && portfolios[customerIdToUse].self){
            const defaultId = portfolios[customerIdToUse].self.id;
            dispatch(setEntityInView(defaultId))
        }
    }, [entityInView, portfolios])

    useEffect(()=>{
        if(myEntity
            && authUser
            && bbDoesUserHaveAccessToBreachRiskLevelForEntity(authUser, "infoLevel2", myEntity.id)
            && myEntity.settings
            &&  myEntity.cycles
            && (!myEntity.cycles[cycleInView] || !myEntity.cycles[myEntity.settings.last_cycle_id])
            && !loadingCycles[cycleInView]){
            dispatch(fetchRiskCycleReport({
                cycleId: cycleInView,
                customerId: customerIdToUse
            }));
        }
    }, [myEntity, cycleInView, entityInView])
    useEffect(()=>{

        if(cycleInView) {
            if (myEntity
                && authUser
                && bbDoesUserHaveAccessToBreachRiskLevelForEntity(authUser, "infoLevel3", myEntity.id)
                //TODO: restore this check for Lite subscription once we update such that all tiles on tech page only rely on summary data (see Slack convo https://breachbits.slack.com/archives/GLM5SQC2Z/p1657044367751359)
                // && (doesUserHaveALiteSubscriptionOrHigher || isAdmin || isStaff)
                && myEntity.settings
                && myEntity.cycles
                && myEntity.cycles[cycleInView] //if there is already a cycle
                && !loadingCycles[cycleInView]
                && !loadingCycleDetails[cycleInView] //if not already loading them
            ) {
                const techData = myEntity.cycles[cycleInView].techData
                //determine what page should be fetched.
                var pageNumToFetch = null;

                //if there is no techData, then fetch page 1.
                if (!techData) { //if no tech data
                    pageNumToFetch = 1;
                } else if ( //if there are pages that have not yet been fetched (first version of this Dec '21 will be simple and assume previous pages have been fetched)
                    //TODO: Logic of this should be more robust. Figure out how to tell which records are missing so you can fetch the correct page?
                    //look at the techData meta to see the highest page number that has been fetched
                    //compare this to the number of pages available
                    //if there are more pages to fetch
                    techData.meta
                    && techData.meta.highestPageFetched
                    && techData.meta.pages
                    && techData.meta.highestPageFetched < techData.meta.pages
                    // && techData.meta.pages > 2  //why was this line in there? Only fetch if 3 or more pages? seems like should have been > 1
                ) {
                    //set the next page to fetch as the next highest page
                    pageNumToFetch = techData.meta.highestPageFetched + 1;

                } else if (
                    techData.meta
                    && techData.meta.highestPageFetched
                    && techData.meta.pages
                    && techData.meta.highestPageFetched >= techData.meta.pages) {

                    //no need to fetch a page because highest page meet or exceeds max pages.
                    console.log("All tech details pages have been fetched. Won't fetch.", techData.meta.highestPageFetched, "out of", techData.meta.pages);
                    pageNumToFetch = null;

                } else {
                    console.warn("brbusiness/index.js Unexpected reason to not fetch another tech details page. Will not fetch. techData", techData, "pageNumToFetch", pageNumToFetch, "myEntity", myEntity, "customerIdToUse", customerIdToUse)
                    pageNumToFetch = null;
                }

                //if we got a valid page number, fetch the details
                if (pageNumToFetch) {
                    console.log("Fetching details page", pageNumToFetch);
                    dispatch(fetchRiskCycleDetailsPagewise(
                        cycleInView,
                        customerIdToUse,
                        pageNumToFetch
                    ));
                }
            }
        }

    }, [cycleInView, techData, loadingCycleDetails, myEntity, loadingCycles]);


    console.log("This is from the search index pages, what are we seeing. entityInview", entityInView, "customerInView", customer, "portfolios", portfolios, "etc...")

    return(
        <>
            <SearchRoutes match={match}/>
        </>
    )
}

export default SearchPageRoutes;